enum IShowCaseTypes {
    desktop,
    mobile,
    text,
    raster
}

export default IShowCaseTypes;